import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import { injectIntl } from 'components';

const styles = () => ({
  activeButton: {
    backgroundColor: '#ff602e',
    height: 40,
    margin: 2,
    minWidth: 40,
    width: 40,
  },
  activeNumberBtnLabel: { color: '#fff' },
  button: {
    height: 40,
    margin: 2,
    minWidth: 40,
    width: 40,
  },
  navBtnLabel: {
    fontSize: 12,
    paddingLeft: 4,
  },
  navBtnWhiteLabel: {
    color: '#fff',
    fontSize: 12,
    paddingLeft: 4,
  },
  nextPrevButton: {
    backgroundColor: '#3a3a3a',
    height: 40,
    margin: 2,
    minWidth: 40,
    width: 40,
  },
  numberBtnLabel: {
    paddingLeft: 12,
    paddingRight: 12,
  },
  numberBtnWhiteLabel: { color: '#fff' },
});

class Pagination extends Component {
  static propTypes = {
    active: PropTypes.number,
    batchCount: PropTypes.number,
    classes: PropTypes.shape({}).isRequired,
    count: PropTypes.number.isRequired,
    light: PropTypes.bool,
    onPageClick: PropTypes.func,
  };

  static defaultProps = {
    active: 0,
    batchCount: 5,
    light: false,
    onPageClick: noop,
  };

  getContents = () => {
    const {
      active,
      batchCount,
      classes,
      count,
      light,
      onPageClick,
    } = this.props;
    const contents = [];
    let start = Math.max(0, active - batchCount);
    const end = Math.min(count, start + (batchCount * 2));

    if (end === count) {
      start = Math.max(0, end - (batchCount * 2));
    }

    for (let i = start; i < end; i++) {
      if (i + 1 !== active) {
        contents.push(
          <Button
            classes={{
              label: light ? classes.numberBtnWhiteLabel : classes.numberBtnLabel,
              root: classes.button,
            }}
            key={i}
            onClick={() => onPageClick(i + 1)}
            variant="text"
          >
            {i + 1}
          </Button>,
        );
      } else {
        contents.push(
          <Button
            classes={{
              label: classes.activeNumberBtnLabel,
              root: classes.activeButton,
            }}
            key={i}
            onClick={() => onPageClick(i + 1)}
            variant="contained"
          >
            {i + 1}
          </Button>,
        );
      }
    }
    return contents;
  }

  render() {
    const {
      active,
      batchCount,
      classes,
      count,
      light,
      onPageClick,
    } = this.props;
    return (
      <div className="pagination-container">
        {
          active > 0 && count > batchCount * 2 && (
            <Button
              classes={{
                label: light ? classes.navBtnWhiteLabel : classes.navBtnLabel,
                root: classes.nextPrevButton,
              }}
              disabled={active === 1}
              onClick={() => onPageClick(Math.max(1, active - (batchCount * 2)))}
              variant="contained"
            >
              {'<<'}
            </Button>
          )
        }
        {count > 1 && this.getContents().map(content => content)}
        {
          count > batchCount * 2 && (
            <Button
              classes={{
                label: light ? classes.navBtnWhiteLabel : classes.navBtnLabel,
                root: classes.nextPrevButton,
              }}
              disabled={active === count}
              onClick={() => onPageClick(Math.min(count, active + (batchCount * 2)))}
              variant="contained"
            >
              {'>>'}
            </Button>
          )
        }
      </div>
    );
  }
}

const wrappedPagination = withStyles(styles)(injectIntl(Pagination));
wrappedPagination.displayName = 'Pagination';

export default wrappedPagination;
